import React from 'react';

import { Group, Text } from '@mantine/core';

interface AgendaHeaderProps {
  columnLabels: string[];
  gridClassName: string;
}

const AgendaHeader = ({ columnLabels, gridClassName }: AgendaHeaderProps): JSX.Element => (
  <Group className={gridClassName}>
    {columnLabels.map(label => (
      <Text key={label} color='dimmed' weight={600} size='0.875rem'>
        {label}
      </Text>
    ))}
  </Group>
);

export default AgendaHeader;
